module.exports = __webpack_public_path__ + "img/Pic6.16e15e05.jpeg";